/**
 * Generates a unique ID for a Tako component.
 * @param {string} componentName - The name of the component.
 * @returns {string} A unique ID string.
 */
export const takoUUID = (componentName: string): string =>
    `tako-${componentName}-${Math.random()}`.replace('.', '');
